import styled from "@emotion/styled";
import UI from "@mile-meeting/mile-ui";

const ComplainEmptyRow = () => {
  return (
    <Row>
      <UI.Icon name="removeCircle" size={24} color="var(--alias-color-label-alternative" />
      <UI.Typography type="body01 normal" fontStyle="regular" color="var(--alias-color-label-normal)">
        등록된 민원이 없습니다.
      </UI.Typography>
    </Row>
  );
};

export default ComplainEmptyRow;

const Row = styled.div`
  box-sizing: border-box;
  padding: 12px 24px;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
  min-width: 1100px;

  border-bottom: 1px solid var(--alias-color-line-normal);
`;